import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { API_GET_BADLA_LIST } from "../utils/api/ApiConstant";
import { getAdminAxios } from "../Services/customService";

const useBadlaType = ({
  badlaType = "all",
  isRemoveSelectedBadla = true, // this flag use for remove selected badla options
  isShowMatchingBadla = true, // this flag use for handle matching type of badla option
} = {}) => {
  const { badlaOptions = [] } = useSelector((state) => state.ui);

  const { isLoading: badlaListLoading, data: badlaListData = [] } = useQuery({
    queryKey: ["badlaListData"],
    queryFn: async () => {
      try {
        const response = await getAdminAxios({
          url: API_GET_BADLA_LIST,
          params: {},
        });
        return response || [];
      } catch (error) {
        console.error("Error fetching badla list:", error);
        return [];
      }
    },
    staleTime: 60000,
  });

  const badlaModifyOptions = useMemo(() => {
    return (
      badlaListData
        .filter((item) => {
          const isTypeMatch = isShowMatchingBadla
            ? badlaType === "all" ||
              item?.badlaType?.toLowerCase() === badlaType.toLowerCase()
            : true;

          const isInBadlaOptions =
            isRemoveSelectedBadla &&
            Array.isArray(badlaOptions) &&
            badlaOptions.some(
              (option) => option?._id?.toString() === item?._id?.toString(),
            );

          return item.isActive && isTypeMatch && !isInBadlaOptions;
        })
        .map(({ settingName, _id }) => ({ label: settingName, value: _id })) ||
      []
    );
  }, [badlaListData, badlaType, badlaOptions, isRemoveSelectedBadla]);

  // const badlaModifyOptions = useMemo(() => {
  //   return badlaListData
  //     .filter((item) => {
  //       // check badlatype condition all or other
  //       const isTypeMatch =
  //         badlaType === "all" ||
  //         item?.badlaType?.toLowerCase() === badlaType.toLowerCase();

  //       // remove option from list which is match in badlaoption array
  //       if (isRemoveSelectedBadla) {
  //         const isInBadlaOptions = Array.isArray(badlaOptions)
  //           ? badlaOptions.some(
  //               (option) => option?._id?.toString() === item?._id?.toString()
  //             )
  //           : false;
  //         return item.isActive && isTypeMatch && !isInBadlaOptions;
  //       }

  //       return item.isActive && isTypeMatch;
  //     })
  //     .map(({ settingName, _id }) => ({ label: settingName, value: _id }));
  // }, [badlaListData, badlaType, badlaOptions]);

  return { badlaModifyOptions, badlaListData, badlaListLoading };
};

export default useBadlaType;
